import { useState, useEffect } from 'react';
import api from '../../../services/api';

export const useFetchAcordos = (pastaId) => {
  const [acordos, setAcordos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAcordos = async () => {
    if (!pastaId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await api.get(`/acordo/acordos/?pasta=${pastaId}`);
      // A API pode retornar { results: [...] } ou diretamente um array
      const data = response.data.results || response.data;
      setAcordos(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || 'Erro ao buscar acordos');
      console.error('Erro ao buscar acordos:', err);
      setAcordos([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAcordos();
  }, [pastaId]);

  return { acordos, loading, error, refetch: fetchAcordos };
};



// WEBPACK FOOTER //
// ./src/pages/Pasta/Acordos/use-fetch-acordos.js